import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MarketType from './MarketType';
import ListGroup from 'react-bootstrap/ListGroup';
import { sortMarketTypes } from '../../utils/sortEquipmentTypes';

const Subtype = ({ classes, subtype, expanded }) => {
  const [open, setOpen] = useState(expanded);
  useEffect(() => {
    if (expanded) {
      setOpen(true);
    }
  }, [expanded]);
  return (
    <React.Fragment>
      <ListGroup.Item 
        className={classNames(classes.clickable)} 
        onClick={() => setOpen(!open)} 
        style={{ backgroundColor: '#f8f9fa' }}
      >
        {subtype.equipment_sub_type_name}
        {open ? <ExpandLess style={{ fontSize: '1.25em' }} /> : <ExpandMore style={{ fontSize: '1.25em' }} />}
      </ListGroup.Item>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <ListGroup
          style={{               
            maxHeight: 'auto',
            overflow: 'auto'
          }}
        >
          {subtype.market_types.sort(sortMarketTypes).map(marketType => (
            <MarketType 
              key={marketType.name}
              classes={classes}
              marketType={marketType}
              showTitle={subtype.market_types.length > 1}
              expanded={!expanded}
            />
          ))}
        </ListGroup>
      </Collapse>
    </React.Fragment>
  );
}

export default Subtype;
